import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';

export const selectGarageStatus = createSelector(selectJsonQuery, jsonQuery =>
  getTermsValue('garage_status')(jsonQuery),
);
